<div [ngClass]="{'p-component-overlay p-loading-mask p-dialog-mask':!enableSpinnerText, 'p-graph-component-overlay p-graph-dialog-mask':enableSpinnerText}">
<p-progressSpinner></p-progressSpinner>
<div *ngIf="enableSpinnerText" class="spinner-graph-text" [innerHTML] = "getFormattedTranslatedData('eiGraphSpinnerMessage')"></div>
</div>